const getApplicationArea = () => window.location.pathname.split('/')[1];

export default getApplicationArea;
